export default __webpack_public_path__ + "static/media/local-two 1.c66c2ca3.svg";